(() => {
  const bindContact = (root) => {
    if (!root || root.dataset.contactBound === 'true') return;
    root.dataset.contactBound = 'true';

    const form = root.querySelector('.ics-contact__form');
    const topicSelect = root.querySelector('[data-contact-topic-select]');
    const routeLinks = root.querySelectorAll('[data-contact-topic]');

    routeLinks.forEach((link) => {
      link.addEventListener('click', () => {
        if (!topicSelect) return;
        const topic = link.dataset.contactTopic;
        const matchingOption = Array.from(topicSelect.options).find((option) => option.value === topic);
        if (matchingOption) {
          topicSelect.value = topic;
          topicSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    if (!form) return;

    form.addEventListener('submit', () => {
      if (!form.checkValidity()) return;
      const submitButton = form.querySelector('[data-contact-submit]');
      const submitLabel = form.querySelector('[data-contact-submit-label]');
      form.classList.add('is-submitting');
      form.setAttribute('aria-busy', 'true');
      if (submitButton) submitButton.disabled = true;
      if (submitLabel) submitLabel.textContent = 'Sending enquiry';
    });
  };

  const bindAll = (scope = document) => {
    if (scope.matches && scope.matches('[data-ics-contact]')) bindContact(scope);
    scope.querySelectorAll('[data-ics-contact]').forEach(bindContact);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bindAll());
  } else {
    bindAll();
  }

  document.addEventListener('shopify:section:load', (event) => bindAll(event.target));
})();
